/**
 * Shared footnote-checkbox + note-textarea pair used by every field type whose `FieldValue` carries
 * `footnote`/`note` (TIER, STARS, RATIO, NUMBER, SHORT_TEXT, LONG_TEXT — not LINK/IMAGE, which have
 * no such fields, and not DURATION, whose footnote is encoded in the text itself via a trailing
 * `" *"`, see `DurationInput`). Disabled until a core value exists — a footnote on "nothing rated
 * yet" isn't meaningful.
 */
interface FootnoteNoteProps {
  footnote: boolean;
  note: string;
  disabled: boolean;
  onFootnoteChange: (footnote: boolean) => void;
  onNoteChange: (note: string) => void;
  onNoteBlur: () => void;
}

export function FootnoteNote({ footnote, note, disabled, onFootnoteChange, onNoteChange, onNoteBlur }: FootnoteNoteProps) {
  return (
    <div className="flex flex-col gap-2 border-t border-border pt-3">
      <label className="flex min-h-tap items-center gap-2 text-sm text-text-muted">
        <input
          type="checkbox"
          checked={footnote}
          disabled={disabled}
          onChange={(event) => onFootnoteChange(event.target.checked)}
          className="size-4 accent-accent"
        />
        Footnote (*)
      </label>
      <label className="flex flex-col gap-1 text-sm text-text-muted">
        <span className="eyebrow">Note</span>
        <textarea
          value={note}
          disabled={disabled}
          onChange={(event) => onNoteChange(event.target.value)}
          onBlur={onNoteBlur}
          rows={2}
          placeholder="Optional context…"
          className="rounded-md border border-border-strong bg-bg px-2 py-1.5 text-sm text-text placeholder:text-text-faint focus:border-accent"
        />
      </label>
    </div>
  );
}
